export default function capitalizeString(string: string | null | undefined, defaultValue: string = ""): string {
  if (!string) {
    return defaultValue;
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
